import moment from "moment-timezone";
import { useCallback, useRef } from "react";
import api from "../../../api";

const useAnalytics = () => {
  const fetchIdAnalyticsRef = useRef(0);

  function CalculateMonthlyTotals(analyticsData) {
    const monthlyTotals = {};

    analyticsData.forEach((record) => {
      const { month_code, total_session_seconds, total_sessions } = record;

      if (!monthlyTotals[month_code]) {
        monthlyTotals[month_code] = {
          total_session_seconds: 0,
          total_sessions: 0,
        };
      }

      monthlyTotals[month_code].total_session_seconds += total_session_seconds;
      monthlyTotals[month_code].total_sessions += total_sessions;
    });
    return monthlyTotals;
  }

  function MapToDateValuePairs(
    monthlyTotals,
    valueKey = "total_session_seconds",
    divisor = 1.0
  ) {
    return Object.entries(monthlyTotals).map(([monthCode, totals]) => {
      return {
        x: moment(monthCode),
        y: Math.round(totals[valueKey] / divisor),
      };
    });
  }

  const FetchAnalyticsData = useCallback(async () => {
    const fetchIdAnalytics = ++fetchIdAnalyticsRef.current;

    var result = null;

    try {
      await new Promise((resolve) => {
        setTimeout(() => {
          resolve(true);
        }, 1000);
      });

      var response = await api.get("usersessions/analytics");

      if (fetchIdAnalytics === fetchIdAnalyticsRef.current) {
        result = response.data;
      }
    } catch (error) {
      console.log(error);
    } finally {
    }

    return result;
  }, []);

  return {
    CalculateMonthlyTotals,
    MapToDateValuePairs,
    FetchAnalyticsData,
  };
};

export default useAnalytics;
